let routes = [
    {
        path: '/',
        name: '经销商管理',
        component: ()=>import('../components/child_router_view'),
        children:[{
            path: '/agent-list',
            name: '经销商列表',
            component: ()=>import('../components/bandu/agent_list'),
        },
        {
            path: '/agent-roles',
            name: '角色管理',
            component: ()=>import('../components/bandu/agent_roles'),
        },
        {
            path: '/agent-admins',
            name: '经销商管理员',
            component: ()=>import('../components/bandu/agent_admins'),
        },
        {
            path: '/agent-regions',
            name: '地域管理',
            component: ()=>import('../components/bandu/agent_regions'),
        },
        {
            path: '/agent-home',
            name: '经销商主页',
            component: ()=>import('../components/bandu/agent_home'),
        },
        {
            path: '/add-agent',
            name: '新建经销商',
            component: ()=>import('../components/bandu/add_agent'),
            hideMenu:true
        },
        {
            path: '/edit-agent',
            name: '编辑经销商',
            component: ()=>import('../components/bandu/add_agent'),
            hideMenu:true
        },
        {
            path: '/agent-detail',
            name: '经销商详情',
            component: ()=>import('../components/bandu/add_agent'),
            hideMenu:true
        }],
        meta: {}
    },
    {
        path: '/',
        name: '伴读课本',
        component: ()=>import('../components/child_router_view'),
        children: [{
            path: '/course-list',
            name: '课本资源',
            component: ()=>import('../components/bandu/course_list')
        },{
            path: '/course-class',
            name: '课本分类',
            component: ()=>import('../components/bandu/course_class')
        },{
            path: '/add-course',
            name: '新建课本',
            component: ()=>import('../components/bandu/add_course'),
            hideMenu:true
        },{
            path: '/edit-course',
            name: '编辑课本',
            component: ()=>import('../components/bandu/add_course'),
            hideMenu:true
        },{
            path: '/add-course-menu',
            name: '新建课本',
            component: ()=>import('../components/bandu/add_course_menu'),
            hideMenu:true
        }]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/bandu.js